<template>
  <div class="popup-window flex" v-if="showPopup">
    <div class="popup-window__inner">
      <img
        src="../assets/imgs/icon-close.png"
        class="popup-window__close"
        @click="handleClose"
      />
      <div class="popup-window__title">{{ popupInfo.title }}</div>
      <div class="popup-window__content" @click="handlePreivewImage">
        <van-image :src="popupInfo.popSrc" class="popup-window__img" />
      </div>
      <div class="popup-window__desc" v-html="popupInfo.desc"></div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";

export default {
  props: {
    popupInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showPopup: true,
    };
  },
  created() {},
  methods: {
    handleClose() {
      this.showPopup = false;
      this.$emit("onclose");
    },
    handlePreivewImage() {
      ImagePreview([this.popupInfo.popSrc]);
    },
  },
};
</script>
<style lang="scss" >
  .popup-window {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.6);
    justify-content: center;
    transition: opacity 0.15s ease;

    &__inner {
      width: 580px;
      height: 690px;
      background-color: #fff;
      border-radius: 24px;
      position: relative;
    }

    &__close {
      width: 48px;
      height: 48px;
      position: absolute;
      right: 20px;
      top: 20px;
    }

    &__title {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 50px;
      margin: 62px auto 28px;
    }

    &__content {
      width: 360px;
      height: 360px;
      margin: 0 auto 23px;
    }

    &__img {
      width: 100%;
      height: 100%;
    }

    &__desc {
      width: 518px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #444444;
      line-height: 44px;
      margin: auto;
      text-align: center;
    }
  }
</style>
